export function WrenchIcon() {
  return (
    <path d="M21.512 6.112l-3.89 3.889l-3.535-3.536l3.889-3.889a6.501 6.501 0 0 0-8.484 8.486l-6.276 6.275a.999.999 0 0 0 0 1.414l2.122 2.122a.999.999 0 0 0 1.414 0l6.275-6.276a6.501 6.501 0 0 0 7.071-1.414a6.504 6.504 0 0 0 1.414-7.071z" fill="currentColor"></path>
  )
}